/**
 * Utility functions for level and tier calculations
 * Based on Daggerheart progression system
 */

/**
 * Calculates the tier based on character level
 * Level 1: Tier 1
 * Level 2-4: Tier 2
 * Level 5-7: Tier 3
 * Level 8-10: Tier 4
 */
export function calculateTierFromLevel(level: number | string): number {
  const numLevel = typeof level === 'string' ? parseInt(level, 10) : level;
  
  if (isNaN(numLevel) || numLevel < 1) return 1;
  if (numLevel === 1) return 1;
  if (numLevel >= 2 && numLevel <= 4) return 2;
  if (numLevel >= 5 && numLevel <= 7) return 3;
  if (numLevel >= 8 && numLevel <= 10) return 4;
  
  // Cap at tier 4 for levels above 10
  return 4;
}

/**
 * Gets the level range for a given tier
 */
export function getLevelRangeForTier(tier: number): string {
  switch (tier) {
    case 1: return 'Level 1';
    case 2: return 'Levels 2-4';
    case 3: return 'Levels 5-7';
    case 4: return 'Levels 8-10';
    default: return 'Unknown';
  }
}

/**
 * Checks if a feature should be available at the current level/tier
 */
export function isFeatureAvailable(featureTier: number, characterLevel: number | string): boolean {
  const currentTier = calculateTierFromLevel(characterLevel);
  return currentTier >= featureTier;
}

/**
 * Gets all tiers available at or below the current level
 */
export function getAvailableTiers(characterLevel: number | string): number[] {
  const currentTier = calculateTierFromLevel(characterLevel);
  const tiers: number[] = [];
  
  for (let tier = 1; tier <= currentTier; tier++) {
    tiers.push(tier);
  }
  
  return tiers;
}